<template>
  <transition @leave="leave">
    <div class="mynd-spinner">
      <div class="spinner-content">
        <div class="icon"></div>
        <div class="info">
          <h5>MyndStorming..</h5>
          <span>{{ loadingStep }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState({
      loadingStep: state => state.api.loadingStep
    })
  },
  methods: {
    leave() {
      // Trigger CSS transition
      $(".spinner").css("opacity", 0);
    }
  }
};
</script>
